export function menuCircular(options = {}) {

    const {
        container  = null,
        maxAngle   = 60,
        xCenter    = 200,   // distance max à droite (centre)
        xEdge      = 120,   // distance min à droite (haut/bas)
        opacityMin = 0.3,
    } = options;

    return (el, t, rect) => {

        if (!container) return;

        const parentRect = container.getBoundingClientRect();
        if (parentRect.top < 0 || parentRect.bottom > window.innerHeight) {
            return;
        }

        const viewportCenter = window.innerHeight / 2;
        const itemY = rect.top + rect.height / 2;

        const distY = itemY - viewportCenter;
        const direction = distY < 0 ? +1 : -1;

        const maxDist = window.innerHeight / 2;

        let relative = Math.abs(distY) / maxDist;
        relative = Math.min(1, relative);

        // ★ angle correct pour orbite à droite
        const angle = -direction * maxAngle * relative;

        // ★ TX correct pour pivot RIGHT → plus négatif au centre, moins négatif aux extrêmes
        const tx = -( xCenter + (xEdge - xCenter) * relative );

        // ★ opacité inchangée
        const opacity = 1 - (1 - opacityMin) * relative;

        el.style.transform = `translateX(${tx}px) rotate(${angle}deg)`;
        el.style.opacity = opacity;
    };
}
